
import { useCallback, useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { initializeSupabase, createTablesIfNotExist } from '@/lib/supabase';

export const useConnectionRetry = () => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [connectionError, setConnectionError] = useState<string | null>(null);
  
  const handleRetryConnection = useCallback(async () => {
    setIsLoading(true);
    setConnectionError(null);
    
    toast({
      title: "Đang thử kết nối lại",
      description: "Vui lòng đợi trong giây lát..."
    });
    
    try {
      const supabaseAvailable = await initializeSupabase();
      
      if (supabaseAvailable) {
        await createTablesIfNotExist();
        setConnectionError(null);
      } else {
        setConnectionError("Vẫn không thể kết nối đến máy chủ, đang sử dụng dữ liệu cục bộ");
        
        toast({
          title: "Kết nối thất bại",
          description: "Không thể kết nối đến máy chủ. Vẫn đang sử dụng dữ liệu cục bộ.",
          variant: "destructive"
        });
      }
    } catch (error) {
      setConnectionError("Lỗi kết nối: " + (error instanceof Error ? error.message : "Lỗi không xác định"));
      
      toast({
        title: "Lỗi kết nối",
        description: "Đã xảy ra lỗi khi thử kết nối lại.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  }, [toast]);

  return { 
    handleRetryConnection,
    isLoading,
    connectionError,
    setConnectionError
  };
};
